import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import PageLoader from '../../components/PageLoader'
import projectsActions from './actions'

class ProjectDeleteConfirmModal extends React.Component {
  componentDidUpdate(prevProps) {
    const { onClose, removingStatus } = this.props
    const { removingStatus: prevRemovingStatus } = prevProps

    if (prevRemovingStatus === 'removing' && removingStatus === 'succeeded') {
      onClose()
    }
  }

  handleSubmit(event) {
    const { id, dispatch } = this.props

    event.preventDefault()

    dispatch(projectsActions.remove(id))
  }

  render() {
    const {
      removingError,
      removingStatus,
      isOpen,
      onClose,
      t
    } = this.props

    return (
      <Modal isOpen={isOpen} toggle={() => onClose()}>
        <Form>
          <ModalHeader toggle={() => onClose()}>
            {t('ProjectDeleteConfirmModal.title')}
          </ModalHeader>
          <ModalBody>
            {t('ProjectDeleteConfirmModal.message')}

            {(removingStatus === 'removing') && (
              <PageLoader message={t('ProjectDeleteConfirmModal.removing')} />
            )}

            {removingStatus === 'failed' && (
              <AlertMessage>{removingError}</AlertMessage>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => onClose()}>
              {t('buttons.cancel', { ns: 'commons' })}
            </Button>
            <Button
              color="danger"
              onClick={(event) => this.handleSubmit(event)}
              type="submit"
            >
              {t('buttons.confirm', { ns: 'commons' })}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}

ProjectDeleteConfirmModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  removingError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  removingStatus: PropTypes.string,
  t: PropTypes.func.isRequired
}

ProjectDeleteConfirmModal.defaultProps = {
  id: null,
  removingError: null,
  removingStatus: 'idle'
}

const mapStateToProps = ({
  projects: {
    removingError,
    removingStatus
  }
}) => ({
  removingError,
  removingStatus
})

export default withTranslation(['ProjectsPage', 'commons'])(
  connect(mapStateToProps)(ProjectDeleteConfirmModal)
)
